/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IdLabel } from './IdLabel';
import {
    IdLabelFromJSON,
    IdLabelFromJSONTyped,
    IdLabelToJSON,
    IdLabelToJSONTyped,
} from './IdLabel';
import type { GenericColors } from './GenericColors';
import {
    GenericColorsFromJSON,
    GenericColorsFromJSONTyped,
    GenericColorsToJSON,
    GenericColorsToJSONTyped,
} from './GenericColors';

/**
 * 
 * @export
 * @interface ContractSummaryDto
 */
export interface ContractSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof ContractSummaryDto
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof ContractSummaryDto
     */
    date: Date;
    /**
     * 
     * @type {GenericColors}
     * @memberof ContractSummaryDto
     */
    statusColor: GenericColors;
    /**
     * 
     * @type {string}
     * @memberof ContractSummaryDto
     */
    statusLabel: string;
    /**
     * 
     * @type {string}
     * @memberof ContractSummaryDto
     */
    support: string;
    /**
     * 
     * @type {IdLabel}
     * @memberof ContractSummaryDto
     */
    contractIdentifier: IdLabel;
    /**
     * 
     * @type {Array<IdLabel>}
     * @memberof ContractSummaryDto
     */
    insureds: Array<IdLabel>;
    /**
     * 
     * @type {string}
     * @memberof ContractSummaryDto
     */
    branchCode: string;
    /**
     * 
     * @type {string}
     * @memberof ContractSummaryDto
     */
    product: string;
    /**
     * Nom lisible du produit (complète le code `product`). Absent si null.
     * @type {string}
     * @memberof ContractSummaryDto
     */
    productLabel?: string | null;
    /**
     * Libellé du tunnel. Absent si null.
     * @type {string}
     * @memberof ContractSummaryDto
     */
    tunnelLabel?: string | null;
    /**
     * Date d'effet du contrat (ISO). Absent si null.
     * @type {Date}
     * @memberof ContractSummaryDto
     */
    effectiveDate?: Date | null;
    /**
     * Fin effective du contrat (ISO, souvent null). Absent si null.
     * @type {Date}
     * @memberof ContractSummaryDto
     */
    endDate?: Date | null;
    /**
     * Échéance principale de reconduction, au format "jj/MM" (⚠️ pas une date ISO). Absent si null. Le tri (sortBy mainDueDate) est chronologique dans l'année.
     * 
     * @type {string}
     * @memberof ContractSummaryDto
     */
    mainDueDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractSummaryDto
     */
    owner: string;
    /**
     * 
     * @type {number}
     * @memberof ContractSummaryDto
     */
    clientPrice?: number;
    /**
     * ID of the associated risk
     * @type {string}
     * @memberof ContractSummaryDto
     */
    riskId?: string;
    /**
     * Number of unread notifications for this contract
     * @type {number}
     * @memberof ContractSummaryDto
     */
    unreadNotificationCount?: number;
    /**
     * Courtier propriétaire du contrat. Rempli uniquement en vue partagée (rôle Plateforme / portefeuille partagé) ; null/absent (WhenWritingNull) en vue courtier classique — détecteur d'affichage de la colonne « Courtier ».
     * 
     * @type {string}
     * @memberof ContractSummaryDto
     */
    brokerId?: string | null;
    /**
     * Nom du courtier (cf. brokerId). Renseigné en vue partagée uniquement.
     * @type {string}
     * @memberof ContractSummaryDto
     */
    brokerName?: string | null;
}



/**
 * Check if a given object implements the ContractSummaryDto interface.
 */
export function instanceOfContractSummaryDto(value: object): value is ContractSummaryDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('statusColor' in value) || value['statusColor'] === undefined) return false;
    if (!('statusLabel' in value) || value['statusLabel'] === undefined) return false;
    if (!('support' in value) || value['support'] === undefined) return false;
    if (!('contractIdentifier' in value) || value['contractIdentifier'] === undefined) return false;
    if (!('insureds' in value) || value['insureds'] === undefined) return false;
    if (!('branchCode' in value) || value['branchCode'] === undefined) return false;
    if (!('product' in value) || value['product'] === undefined) return false;
    if (!('owner' in value) || value['owner'] === undefined) return false;
    return true;
}

export function ContractSummaryDtoFromJSON(json: any): ContractSummaryDto {
    return ContractSummaryDtoFromJSONTyped(json, false);
}

export function ContractSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'date': (new Date(json['date'])),
        'statusColor': GenericColorsFromJSON(json['statusColor']),
        'statusLabel': json['statusLabel'],
        'support': json['support'],
        'contractIdentifier': IdLabelFromJSON(json['contractIdentifier']),
        'insureds': ((json['insureds'] as Array<any>).map(IdLabelFromJSON)),
        'branchCode': json['branchCode'],
        'product': json['product'],
        'productLabel': json['productLabel'] == null ? undefined : json['productLabel'],
        'tunnelLabel': json['tunnelLabel'] == null ? undefined : json['tunnelLabel'],
        'effectiveDate': json['effectiveDate'] == null ? undefined : (new Date(json['effectiveDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'mainDueDate': json['mainDueDate'] == null ? undefined : json['mainDueDate'],
        'owner': json['owner'],
        'clientPrice': json['clientPrice'] == null ? undefined : json['clientPrice'],
        'riskId': json['riskId'] == null ? undefined : json['riskId'],
        'unreadNotificationCount': json['unreadNotificationCount'] == null ? undefined : json['unreadNotificationCount'],
        'brokerId': json['brokerId'] == null ? undefined : json['brokerId'],
        'brokerName': json['brokerName'] == null ? undefined : json['brokerName'],
    };
}

export function ContractSummaryDtoToJSON(json: any): ContractSummaryDto {
    return ContractSummaryDtoToJSONTyped(json, false);
}

export function ContractSummaryDtoToJSONTyped(value?: ContractSummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'date': ((value['date']).toISOString().substring(0,10)),
        'statusColor': GenericColorsToJSON(value['statusColor']),
        'statusLabel': value['statusLabel'],
        'support': value['support'],
        'contractIdentifier': IdLabelToJSON(value['contractIdentifier']),
        'insureds': ((value['insureds'] as Array<any>).map(IdLabelToJSON)),
        'branchCode': value['branchCode'],
        'product': value['product'],
        'productLabel': value['productLabel'],
        'tunnelLabel': value['tunnelLabel'],
        'effectiveDate': value['effectiveDate'] == null ? undefined : ((value['effectiveDate'] as any).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate'] as any).toISOString()),
        'mainDueDate': value['mainDueDate'],
        'owner': value['owner'],
        'clientPrice': value['clientPrice'],
        'riskId': value['riskId'],
        'unreadNotificationCount': value['unreadNotificationCount'],
        'brokerId': value['brokerId'],
        'brokerName': value['brokerName'],
    };
}

